import { ChangeDetectorRef, Component, Input } from '@angular/core';

import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

import { IconName } from '@recruitee/user-interface';

import { FeatureGuardFacade } from '../feature-guard.facade';
import { FeatureGuardComponent, FeatureGuardMode, GuardedFeature } from '../feature-guard.types';

@Component({
  selector: 'rt-feature-guard-dropdown-item',
  templateUrl: `feature-guard-dropdown-item.component.html`,
  styleUrls: ['feature-guard-dropdown-item.component.less'],
})
export class FeatureGuardDropdownItemComponent implements FeatureGuardComponent {
  @Input() public mode: FeatureGuardMode;
  @Input() public feature: GuardedFeature;
  @Input() public iconName: IconName;
  @Input() public heading: string;
  @Input() public subheading: string;
  @Input() public useOriginalTemplate: boolean;

  public enabled: boolean = false;
  public features: string[];
  public isProtected: boolean = true;

  private ngOnDestroy$ = new Subject<void>();

  constructor(public facade: FeatureGuardFacade, protected cdRef: ChangeDetectorRef) {}

  public ngOnInit() {
    if (!this.feature) {
      this.isProtected = false;
    } else {
      this.facade
        .checkFeatureAvailability(this.feature)
        .pipe(takeUntil(this.ngOnDestroy$.asObservable()))
        .subscribe(enabled => {
          this.enabled = enabled;
          this.cdRef.detectChanges();
        });
    }
  }

  public ngOnDestroy(): void {
    this.ngOnDestroy$.next();
    this.ngOnDestroy$.complete();
  }
}
